/* src/app/modules/print-cards/components/cards/backgrounds/post-cards-4x6/doug-post-card-stack-background/doug-post-card-stack-background.component.scss */
:host {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
  padding: 0.625rem;
  box-sizing: border-box;
}
:host .main-content {
  flex: 1;
}
:host .main-content .print-card-background-asset {
  height: 100%;
  width: 100%;
}
:host .card-header {
  background-color: #000000;
  height: 10.9%;
  width: 100%;
  border-radius: 0.5rem 0.5rem 0 0;
}
/*# sourceMappingURL=doug-post-card-stack-background.component.css.map */
